
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/PropertyResearchLandingPage",
      function () {
        return require("private-next-pages/landingPages/PropertyResearchLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/PropertyResearchLandingPage"])
      });
    }
  